import { Api } from 'models/services/api';
import { ReadMenuCategoriesQuery } from 'models/services/graphql';

import { MenuCategoryCollectionData } from '../collection';

type DataToFetch = {
  businessId: string;
  nextToken?: string;
};

const RequestQuery = `
  query ReadMenuCategories($businessId: ID!, $nextToken: String) {
    ${ReadMenuCategoriesQuery}
  }
`;

type ResponseData = {
  data: {
    readMenuCategories: MenuCategoryCollectionData;
  }
}

class ReadCollectionGql {

  readonly result?: MenuCategoryCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToFetch): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readMenuCategories;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionGql };